module.exports = __webpack_public_path__ + "static/img/criminal-no-content.e36a98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/状态图标/criminal-no-content.png
// module id = 3//e
// module chunks = 33